import { z } from 'zod';

export const idBasedLookupSchema = z.object({
  id: z.number(),
  name: z.string()
});

export type IdBasedRef = z.infer<typeof idBasedLookupSchema>;

export const codeBasedLookupSchema = z.object({
  code: z.string(),
  name: z.string()
});

export type CodeBasedRef = z.infer<typeof codeBasedLookupSchema>;
